import React from 'react';
import { Row, Col } from 'antd';
import { Colors } from '@common/tokens';
import { clsx } from 'clsx';

type Props = {
  label: string;
  info: string | JSX.Element;
  className?: string;
};

export function MemberViewDrawerInfoRow({ label, info, className }: Props) {
  return (
    <div className={clsx('member-view-drawer__info', className)}>
      <Row gutter={[0, 12]}>
        <Col span={6}>
          <label className="member-view-drawer__info-label">{label}</label>
        </Col>
        <Col span={18}>{info}</Col>
      </Row>
      <style jsx>{`
        .member-view-drawer__info {
          font-size: 16px;
          margin-bottom: 12px;
        }
        .member-view-drawer__info-label {
          color: ${Colors.midnightLighter};
        }
      `}</style>
    </div>
  );
}
